$(document).ready(function() {
  //Testimonial Slider
  $('.test_grid').owlCarousel({
      loop:true,
      margin:23,
      nav:true,
      dots: false,
      autoHeight:true,
      items:3,
      navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="22.708" height="40" viewBox="0 0 22.708 40"><path id="Path_1463" data-name="Path 1463" d="M53.5,56.763a2.713,2.713,0,0,0,1.913-4.626L40.039,36.762,55.414,21.388a2.708,2.708,0,0,0-3.827-3.834L34.292,34.849a2.707,2.707,0,0,0,0,3.827L51.587,55.97a2.688,2.688,0,0,0,1.913.792Z" transform="translate(-33.5 -16.763)" fill="#5a3b21"/></svg>','<svg xmlns="http://www.w3.org/2000/svg" width="22.708" height="40" viewBox="0 0 22.708 40"><path id="Path_1462" data-name="Path 1462" d="M36.208,56.763a2.713,2.713,0,0,1-1.913-4.626L49.669,36.762,34.295,21.388a2.708,2.708,0,0,1,3.827-3.834L55.416,34.849a2.707,2.707,0,0,1,0,3.827L38.121,55.97a2.688,2.688,0,0,1-1.913.792Z" transform="translate(-33.5 -16.763)" fill="#5a3b21"/></svg>'],
      responsive:{
          0:{
              items:1,
              margin:0,
              autoHeight:true,
          },
          768:{
              items:2,
          },
          992:{
              items:3,
          },
          1200:{
              items:3,
            margin:30,
          }
      }
  })
  //Hero Section
  $('.hero_items_row').owlCarousel({
      loop:false,
      margin:0,
      nav:false,
      dots: false,
      touchDrag: false,
      mouseDrag: false,
      items:1,
      autoplay:true,
      autoplayTimeout:4000,
      autoplayHoverPause:true
  })
});




// testimonial less
$('a.moreless-button').click(function() {
    if (($(this).text()) == "read more") {
        $(this).text("read less");
    } else {
        $(this).text("read more");
    }
});

